import { Flex } from "antd";
import { ChoiceCard, ScrollableRow } from "@libertify/ui";

export type DnaChoiceOption<T extends string> = {
  value: T;
  label: string;
  description: string;
};

export type DnaChoiceRowProps<T extends string> = Readonly<{
  options: DnaChoiceOption<T>[];
  selected: T | null;
  onSelect: (value: T) => void;
}>;

// Fixed card width so a row of options scrolls sideways instead of squeezing.
const CARD_WIDTH = 260;

export const DnaChoiceRow = <T extends string>({
  options,
  selected,
  onSelect,
}: DnaChoiceRowProps<T>) => (
  <ScrollableRow>
    <Flex gap={12}>
      {options.map(({ value, label, description }) => (
        <Flex key={value} style={{ flex: `0 0 ${CARD_WIDTH}px` }}>
          <ChoiceCard
            label={label}
            description={description}
            selected={selected === value}
            showCheckmark
            onClick={() => onSelect(value)}
          />
        </Flex>
      ))}
    </Flex>
  </ScrollableRow>
);
